import * as React from 'react';

import { Button } from '@cian/button-component';
import { ButtonLabelWrapper } from '../ButtonLabelWrapper';
import { PencilIcon } from '../icons';

export interface IEditButtonProps {
  entityId: number;
  onClick(): void;
}

export class EditButton extends React.PureComponent<IEditButtonProps, {}> {
  public render() {
    const { onClick } = this.props;

    return (
      <div>
        <Button size="S" theme="ghost" onClick={onClick}>
          <ButtonLabelWrapper Icon={PencilIcon} label="Редактировать" />
        </Button>
      </div>
    );
  }
}
